import { Personas } from '@/enums/persona';
import {
  Component, InjectReactive, Prop, Vue,
} from 'vue-property-decorator';
import WithRender from './base-persona.html';

@WithRender
@Component({
  name: 'BasePersona',
  // inject: ['persona'],
})
export default class BasePersona extends Vue {
  @Prop({ default: () => [] })
  public targetPersonas!:Personas[];

  @InjectReactive()
  public persona!: Personas;

  public get isMatchedPersona() {
    return this.targetPersonas.some(((target) => target === this.persona));
  }
}
